/**
 * 组件使用场景：添加买家
 * */
import React, { Component } from 'react';
import { Modal, Form, Steps, Button, Input } from 'antd';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import styles from '../_style/index.less';
import { CHECK_name, CHECK_phone, CHECK_buyerCode, CHECK_idCard } from '@/shared/reqexp';
import { CarPosition } from '@/components';
const mapStateToProps = (rootState) => ({
    buyer: rootState.buyer,
});
class AddBuyerComponent extends Component {
    constructor(props) {
        super(props);
        this.timer = null;
        this.second = 60;
        this.checkedPosition = [];
        this.state = {
            steps: [
                {
                    title: '实名认证',
                },
                {
                    title: '添加手机',
                },
                {
                    title: '完善信息',
                },
            ],
            gettingCode: false,
            second: this.second,
        };
        this.cancel = this.cancel.bind(this);
        this.afterClose = this.afterClose.bind(this);
        this.next = this.next.bind(this);
        this.getReqCode = this.getReqCode.bind(this);
    }
    // desc 关闭回调
    cancel() {
        dispatch.buyer.HIDE_ADD_MODAL();
    }
    // desc 关闭后重置数据
    afterClose() {
        this.props.form.resetFields();
        dispatch.buyer.RESET_ADD_MODAL();
        this.timer && clearInterval(this.timer);
        this.timer = null;
        this.setState({
            gettingCode: false,
            second: this.second,
        });
    }
    // desc 下一步or完成
    next() {
        this.props.form.validateFields()
            .then((formData) => {
            const { currentShow } = this.props.buyer;
            switch (currentShow) {
                case 0:
                    dispatch.buyer.addReq({
                        formData: Object.assign(Object.assign({}, formData), { contactType: 10 }),
                        callback: this.getReqCode,
                    });
                    break;
                case 1:
                    dispatch.buyer.addPhone({
                        formData: Object.assign({}, formData),
                    });
                    break;
                case 2:
                    if (formData.position) {
                        delete formData.position;
                        const [provinceData, cityData] = this.checkedPosition;
                        formData.provinceCode = provinceData.value;
                        formData.provinceName = provinceData.label;
                        formData.cityCode = cityData.value;
                        formData.cityName = cityData.label;
                    }
                    if (formData.numberPlate) {
                        formData.numberPlate = formData.numberPlate.padStart(3, '0');
                    }
                    dispatch.buyer.addCode({
                        formData: Object.assign({}, formData),
                        callback: this.props.onOk || null,
                    });
                    break;
            }
        });
    }
    // desc 获取验证码
    getReqCode() {
        const { gettingCode } = this.state;
        const { isAuthentication, authenticationData } = this.props.buyer;
        const mobile = isAuthentication ? authenticationData.mobile : (this.props.form.getFieldValue('mobile') || this.props.buyer.addData.mobile);
        if (!gettingCode) {
            if (mobile) {
                this.sendCode(mobile);
            }
            else {
                !isAuthentication && this.props.form.validateFields(['phone'])
                    .then((formData) => {
                    this.sendCode(formData.phone);
                });
            }
        }
    }
    sendCode(mobile) {
        dispatch.buyer.getReqCode({
            mobile,
            callback: () => {
                this.setState({
                    gettingCode: true,
                });
                this.changeSecond();
            },
        });
    }
    // desc 发送验证码读秒
    changeSecond() {
        this.timer = setInterval(() => {
            const { second } = this.state;
            if (second === 1) {
                clearInterval(this.timer);
                this.timer = null;
                this.setState({
                    second: this.second,
                    gettingCode: false,
                });
            }
            else {
                this.setState({
                    second: second - 1,
                });
            }
        }, 1000);
    }
    // desc 添加-第一步：实名认证
    renderStep1() {
        const { getFieldDecorator } = this.props.form;
        return (<div>
        <Form.Item label={'姓名'}>
          {getFieldDecorator('realName', {
            rules: [
                {
                    required: true,
                    message: '请输入姓名',
                },
                {
                    validator: CHECK_name(50),
                },
            ],
        })(<Input placeholder="请输入姓名"/>)}
        </Form.Item>
        <Form.Item label={'身份证'}>
          {getFieldDecorator('contactCode', {
            rules: [
                {
                    required: true,
                    message: '请输入身份证号',
                },
                {
                    pattern: CHECK_idCard,
                    message: '请输入正确格式的身份证号',
                },
            ],
        })(<Input placeholder="请输入身份证号"/>)}
        </Form.Item>
      </div>);
    }
    // desc 添加-第二步：验证手机号
    renderStep2() {
        const { getFieldDecorator } = this.props.form;
        const { gettingCode, second } = this.state;
        const { isCheYiPai, addData } = this.props.buyer;
        return (<div>
        {!isCheYiPai && (<Form.Item label={'手机号'}>
            {getFieldDecorator('mobile', {
            initialValue: addData.mobile,
            rules: [
                {
                    required: true,
                    message: '请输入手机号',
                },
                {
                    pattern: CHECK_phone,
                    message: '请输入正确格式的手机号',
                },
            ],
        })(<Input placeholder="请输入手机号"/>)}
          </Form.Item>)}
        <Form.Item label={'验证码'}>
          {getFieldDecorator('verificationCode', {
            rules: [
                {
                    required: true,
                    message: '请输入验证码',
                },
            ],
        })(<Input placeholder="请输入验证码" suffix={<div style={{
            cursor: 'pointer',
            color: gettingCode ? '#AAAAAA' : '#FF571A',
            fontSize: 14,
        }} onClick={this.getReqCode}>
                {gettingCode ? `重新发送(${second}s)` : '获取验证码'}
              </div>}/>)}
        </Form.Item>
      </div>);
    }
    // desc 添加-第三步：添加号牌
    renderStep3() {
        const { getFieldDecorator } = this.props.form;
        return (<div>
        <Form.Item label={<>号码牌<span style={{ color: '#999999' }}>(选填)</span></>}>
          {getFieldDecorator('numberPlate', {
            rules: [
                {
                    pattern: CHECK_buyerCode,
                    message: '请输入3位数字号牌(000-999)',
                },
            ],
        })(<Input placeholder="请输入号码牌"/>)}
        </Form.Item>
        <Form.Item label={<>维护人<span style={{ color: '#999999' }}>(选填)</span></>}>
          {getFieldDecorator('maintainer', {
            rules: [
                {
                    validator: CHECK_name(50),
                },
            ],
        })(<Input placeholder="请输入姓名"/>)}
        </Form.Item>
        <Form.Item label={<>所在地<span style={{ color: '#999999' }}>(选填)</span></>}>
          {getFieldDecorator('position')(<CarPosition CascaderProps={{
            placeholder: '请选择',
        }} onChange={(val, options) => {
            this.checkedPosition = options;
        }} precision={'city'}/>)}
        </Form.Item>
      </div>);
    }
    render() {
        const { steps } = this.state;
        const { visible, currentShow, tip, requesting } = this.props.buyer;
        return (<Modal centered footer={null} visible={visible} width={600} onCancel={this.cancel} afterClose={this.afterClose}>
        <div className={styles.add_buyer}>
          <div className={styles.add_title}>
            添加买家
          </div>
          <div style={{ width: '90%' }}>
            <Steps className={'add-step'} size={'small'} current={currentShow}>
              {steps.map((v, i) => (<Steps.Step {...v} key={i}/>))}
            </Steps>
            <div className={styles.add_tip}>
              {tip.map((v, i) => (<React.Fragment key={i}>
                    <span>{v}</span><br />
                  </React.Fragment>))}
            </div>
            <Form labelCol={{
            span: 5,
            offset: 2,
        }} wrapperCol={{ span: 14 }}>
              {currentShow === 0 && this.renderStep1()}
              {currentShow === 1 && this.renderStep2()}
              {currentShow === 2 && this.renderStep3()}
            </Form>
          </div>
          <Button type="primary" className="add-btn" onClick={this.next} loading={requesting}>
            {currentShow === 2 ? '完成' : '下一步'}
          </Button>
        </div>
      </Modal>);
    }
}
export default connect(mapStateToProps)(Form.create()(AddBuyerComponent));
